import { render, staticRenderFns } from "./MusicaChile.vue?vue&type=template&id=db49dafe&"
import script from "./MusicaChile.vue?vue&type=script&lang=js&"
export * from "./MusicaChile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports